const listeners = {};

export const editorBridge = {
  on(event, handler) {
    if (!listeners[event]) listeners[event] = new Set();
    listeners[event].add(handler);
    return () => listeners[event].delete(handler);
  },

  emit(event, payload) {
    (listeners[event] || []).forEach((handler) => {
      try {
        handler(payload);
      } catch (err) {
        console.error(`editorBridge.${event}`, err);
      }
    });
  },

  ready(template) {
    this.emit('page.ready', template);
  },

  save(options = {}) {
    this.emit('editor.save', options);
  },

  updatePreview() {
    this.emit('editor.update', {});
  },

  templateSaved(previewPath) {
    this.emit('save.template', previewPath);
  },

  editorLoaded() {
    this.emit('editor.loaded', {});
  },
};

export default editorBridge;
